<div class="plan-selector">
    <div class="billing-selector flex justify-center mb-8">
        <div class="inline-flex rounded-md shadow-sm" role="group">
            <button type="button"
                [class]="billingPeriod === 'monthly' ? 'billing-period-active' : 'billing-period-inactive'"
                (click)="setBillingPeriod('monthly')">Mensual</button>
            <button type="button"
                [class]="billingPeriod === 'yearly' ? 'billing-period-active' : 'billing-period-inactive'"
                (click)="setBillingPeriod('yearly')">Anual</button>
        </div>
    </div>

    <div class="plans-container grid grid-cols-1 md:grid-cols-2 gap-6">
        <div *ngFor="let plan of plans" class="plan-card" [class.plan-selected]="selectedPlanId === plan.id"
            (click)="selectPlan(plan)">
            <div class="plan-header">
                <h3 class="plan-title">{{ plan.nombre }}</h3>
                <div class="plan-price">
                    <span *ngIf="billingPeriod === 'monthly'">
                        {{ plan.precio_mensual | dolar: plan.tipo_moneda_id }} / mensual
                    </span>
                    <span *ngIf="billingPeriod === 'yearly'">
                        {{ plan.precio_anual | dolar: plan.tipo_moneda_id }} / anual
                    </span>
                </div>
            </div>

            <div class="plan-features">
                <ul *ngFor="let feature of plan.modulos_detalle">
                    <li>{{ feature.descripcion }}</li>
                </ul>
                <ul>
                    <li *ngIf="plan.limite_usuarios > 0">Hasta {{ plan.limite_usuarios }} usuarios</li>
                    <li *ngIf="plan.limite_personas > 0">Hasta {{ plan.limite_personas }} personas</li>
                    <li *ngIf="plan.limite_medios > 0">Hasta {{ plan.limite_medios }} medios</li>
                    <li *ngIf="plan.limite_clientes > 0">Hasta {{ plan.limite_clientes }} clientes</li>
                    <li *ngIf="plan.limite_campanias > 0">Hasta {{ plan.limite_campanias }} campañas</li>
                    <li *ngIf="plan.limite_plan_medios > 0">Hasta {{ plan.limite_plan_medios }} planes de medios</li>
                    <li *ngIf="plan.limite_nota_prensas > 0">Hasta {{ plan.limite_nota_prensas }} notas de prensa</li>
                    <li *ngIf="plan.limite_impactos > 0">Hasta {{ plan.limite_impactos }} impactos</li>
                </ul>
            </div>

            <div class="plan-trial">
                <span *ngIf="plan.is_trial">Período de prueba: {{ plan.dias_prueba }} días</span>
                <span *ngIf="!plan.is_trial">Período de prueba: No tiene</span>
            </div>
        </div>
    </div>

    <div class="flex justify-center gap-4 mt-8" *ngIf="showContinueButton || showPayButton">
        <button mat-raised-button color="primary" *ngIf="showContinueButton" [disabled]="!selectedPlanId"
            (click)="onContinue()">
            {{ continueButtonLabel }}
        </button>

        <button mat-raised-button color="primary" *ngIf="showPayButton" [disabled]="!selectedPlanId || isLoading"
            (click)="onPay()">
             <mat-icon>attach_money</mat-icon>
            {{ payButtonLabel }}
        </button>

        <button mat-raised-button color="secondary" (click)="onBack()">
            Volver
        </button>

        <ng-content select="[secondary-action]"></ng-content>
    </div>
</div>